import React, { useId, useState } from 'react'

export function Card ({ children, className = '', ...props }) {
  return <section className={`ui-card ${className}`.trim()} {...props}>{children}</section>
}

export function Badge ({ children, tone = 'neutral' }) {
  return <span className='ui-badge' data-tone={tone}>{children}</span>
}

export function Status ({ children, className = '', tone = 'neutral', ...props }) {
  return <span className={`ui-status ${className}`.trim()} data-tone={tone} {...props}>{children}</span>
}

export function Accordion ({ title, ariaLabel, children, className = '', defaultOpen = false, description, open: controlledOpen, onOpenChange }) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen)
  const panelId = useId()
  const open = controlledOpen ?? internalOpen

  function toggle () {
    const nextOpen = !open
    if (controlledOpen == null) setInternalOpen(nextOpen)
    onOpenChange?.(nextOpen)
  }

  return (
    <div className={`ui-accordion ${className}`.trim()}>
      <button className='ui-accordion__trigger' aria-label={ariaLabel || (typeof title === 'string' ? title : undefined)} aria-expanded={open} aria-controls={panelId} onClick={toggle}>
        <span className='ui-accordion__heading'><strong>{title}</strong>{description && <small>{description}</small>}</span>
        <span className='ui-accordion__state' aria-hidden='true'>{open ? 'Свернуть' : 'Развернуть'}</span>
      </button>
      {open && <div id={panelId} className='ui-accordion__panel'>{children}</div>}
    </div>
  )
}

export function InlineAlert ({ title, children, tone = 'info' }) {
  return <div className='ui-alert' data-tone={tone} role='alert'>{title && <strong className='ui-alert__title'>{title}</strong>}{children}</div>
}

export function EmptyState ({ title, description, actions }) {
  return <div className='ui-empty' role='status'><h3>{title}</h3>{description && <div>{description}</div>}{actions}</div>
}

export function Skeleton (props) {
  return <div className='ui-skeleton' aria-busy='true' role='progressbar' {...props} />
}

export function PageHeader ({ title, description, actions }) {
  return <header className='ui-page-header'><div><h1>{title}</h1>{description && <p>{description}</p>}</div>{actions && <div>{actions}</div>}</header>
}

export function ActionBar ({ children }) {
  return <div className='ui-action-bar'>{children}</div>
}

export function MappingEditorShell ({ source, target }) {
  return <div className='ui-mapping-shell'><div>{source}</div><div className='ui-mapping-shell__arrow' aria-hidden='true'>→</div><div>{target}</div></div>
}
